import {
  dialogStore,
  Footer,
  PrimaryButton,
  // PrimaryButton,
  SecondaryButton,
  UCLColorKey,
} from "@ucl/library";
import { useState } from "react";
import ToastV2 from "../../ToastV2/ToastV2";

const dialogIdBase = "confirm-dialog-v2";

export interface ConfirmDialogProps {
  dialogId: string;
  headerText?: string;
  content: React.ReactNode;
  confirmButtonText?: string;
  loadingProgressContent?: string;
  loadingSuccessContent?: string;
  onConfirm?: () => Promise<{ isSuccess: boolean; error: any }>;
  shouldHideCancelButton?: boolean;
  cancelButtonText?: string;
  footerClassName?: string;
  color?: UCLColorKey;
}

export const openConfirmDialog = (props: ConfirmDialogProps) => {
  dialogStore.openDialog({
    id: `${dialogIdBase}-${props.dialogId}`,
    className: `${dialogIdBase}-container`,
    header: props.headerText ?? "Confirm",
    allowDragging: false,
    content: () => (
      <>
        <div className={`${dialogIdBase}-content`}>{props.content}</div>
        <ConfirmDialogFooter {...props} />
      </>
    ),
    close: () => closeConfirmDialog(props.dialogId),
  });
};

export const closeConfirmDialog = (dialogId: string) => {
  dialogStore.closeDialog(`${dialogIdBase}-${dialogId}`);
};

const ConfirmDialogFooter: React.FC<ConfirmDialogProps> = (props) => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Footer className={props.footerClassName}>
      {!props.shouldHideCancelButton && (
        <SecondaryButton
          text={props.cancelButtonText ?? "Cancel"}
          onClick={() => closeConfirmDialog(props.dialogId)}
        />
      )}
      <PrimaryButton
        text={props.confirmButtonText || "Confirm"}
        // color={props.color || "sky-blue"}
        isLoading={isLoading}
        loadingProgressContent={props.loadingProgressContent}
        loadingSuccessContent={props.loadingSuccessContent}
        onClick={async () => {
          setIsLoading(true);
          const result = props.onConfirm && (await props.onConfirm());
          setIsLoading(false);

          if (result?.isSuccess) {
            closeConfirmDialog(props.dialogId);
          } else if (result?.error) {
            ToastV2.showFailedActionToaster(result.error.message);
            closeConfirmDialog(props.dialogId);
          }
        }}
      />
    </Footer>
  );
};
